import { TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Table } from 'react-bootstrap';
import CurrencyFormat from 'react-currency-format';
import { formatCustomNumber } from '../../helpers/formatCustomNumber';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function SalesReturnItemList(props) {
  return (
    <>
      <div className="">
        <TableContainer className="mt-3 w-full bg-white">
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <colgroup>
              <col style={{ width: '40%' }} />
              <col style={{ width: '10%' }} />
              <col style={{ width: '10%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
            </colgroup>
            <TableHead style={{ backgroundColor: '#F1F1F1' }}>
              <TableRow>
                <TableCell className="subheading">Returned item(s) Details</TableCell>

                {/* <TableCell className="subheading">Minimum Pay</TableCell> */}
                <TableCell className="subheading">Unit</TableCell>
                <TableCell className="subheading">Order Quantity</TableCell>
                <TableCell className="subheading">Return Quantity</TableCell>
              </TableRow>
            </TableHead>

            <TableBody className=" mb-3">
              {props?.tableData?.map((item, i) => {
                return (
                  <TableRow className="border-1" key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell className="subheading" align="left">
                      {item.item_name}{' '}
                    </TableCell>
                    <TableCell className="subheading" align="left">
                      {item.item_description}
                    </TableCell>

                    <TableCell className="subheading" align="left">
                      {item.sales_order_quantity}
                    </TableCell>

                    <TableCell className="subheading" align="left">
                      {formatCustomNumber(item.item_return_quantity)}
                    </TableCell>

                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}

export default SalesReturnItemList;
